import {defineStore} from 'pinia';
import menuConfig from "@/js/menu.ts";

export const useThemeStore = defineStore('themeStore', {
    state: () => ({
        theme: 'light',
        themeTypes: {
            light: 'light',
            dark: 'dark',
        },
        footer_with_map: true,
        body_overflow_hidden: true,
        toasts: [],
    }),
    actions: {
        isDarkTheme() {
            return this.theme === this.themeTypes.dark
        },
        isLightTheme() {
            return this.theme === this.themeTypes.light
        },
        activateDarkTheme() {
            this.theme = this.themeTypes.dark
        },
        activateLightTheme() {
            this.theme = this.themeTypes.light
        },
        turnOffMap() {
            this.footer_with_map = false
        },
        turnOnMap() {
            this.footer_with_map = true
        },
        resetMap() {
            this.footer_with_map = true
        },
        setBodyOverflow(hidden) {
            this.body_overflow_hidden = hidden
            document.body.style.overflow = this.body_overflow_hidden ? 'hidden' : '';
        },
        addToast(message, type, timeout = 3000) {
            const id = Date.now() + Math.random().toString(36).substring(2, 9);
            this.toasts.push({id, message, type})

            let vm = this
            if (this.toasts.length >= 3) {
                console.log(123)
                this.removeToast(this.toasts[0].id);
            }

            setTimeout(() => {
                vm.removeToast(id)
            }, timeout)
        },
        removeToast(id) {
            this.toasts = this.toasts.filter(toast => toast.id !== id)
        }
    }
});
